import groq from 'groq'

export const products = groq`
 _type,
  topNote,
  productsList[] {
    title,
    subtitle,
    description,
    comingSoon,
  },
  description,
`
